module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Julie Earle was born in 1976 and raised in Luton, England. Her father told her fairy stories from his own imagination which captivated her into a fantasy world. As she grew up, she took her imaginative skills to school and got her first story published in the school magazine. After leaving school, Julie worked in a small playgroup filling children’s imagination with all her stories. She loved working with children and went on to receive a diploma in nursery nursing. She now lives in Essex with her husband and five children. Her passion for writing took over and she became a member of a freelance writing group. After having her fourth child, Julie began to create "), _c('em', [_vm._v("The Magical Gate")]), _vm._v(" series; and so it was born.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0